/**
 * Microsoft Clarity wrapper.
 *
 * The loader script is injected by GTM (Custom HTML tag firing All Pages) —
 * NOT bundled in this codebase. These helpers no-op silently when
 * `window.clarity` is missing (dev, ad blockers, GTM not yet published) and
 * never throw, so analytics can never break the page.
 */

declare global {
  interface Window {
    clarity?: ((...args: unknown[]) => void) & { q?: unknown[] };
  }
}

function safeCall(...args: unknown[]): void {
  try {
    if (typeof window === "undefined") return;
    const c = window.clarity;
    if (typeof c !== "function") return;
    c(...args);
  } catch {
    // swallow — analytics must never break the page
  }
}

export function clarityEvent(name: string): void {
  safeCall("event", name);
}

export function claritySet(key: string, value: string | number | boolean): void {
  safeCall("set", key, String(value));
}

export function clarityUpgrade(reason: string): void {
  safeCall("upgrade", reason);
}

export function clarityIdentify(userId: string, sessionId?: string, pageId?: string): void {
  safeCall("identify", userId, sessionId, pageId);
}